export const LOAD_CHANGELOG = "LOAD_CHANGELOG";
export const CLEAR_CHANGELOG = "CLEAR_CHANGELOG";
